export const LINK = () => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
      fill="#375BD2"
    />
    <path
      d="M16.0001 4L5.60767 10V22L16.0001 28L26.3925 22V10L16.0001 4ZM21.9885 19.4576L16.0001 22.9148L10.0117 19.4576V12.5424L16.0001 9.0852L21.9885 12.5424V19.4576Z"
      fill="white"
    />
  </svg>
);
